const PDF_PAGE_SELECTOR = '[data-pdf-page-wrapper="true"]';

const getAvailableWidth = (pagesContainer) => (
  pagesContainer?.clientWidth || pagesContainer?.parentElement?.clientWidth || 0
);

/**
 * Resize already-rendered PDF pages without recreating their canvases.
 * A zoom of 100% means "fit if needed", while smaller pages keep their
 * natural rendered width.
 */
export const updatePdfPageDisplaySizes = (pagesContainer, zoomScale) => {
  const availableWidth = getAvailableWidth(pagesContainer);
  const normalizedZoom = Number(zoomScale);

  if (!pagesContainer || availableWidth <= 0 || !Number.isFinite(normalizedZoom) || normalizedZoom <= 0) {
    return;
  }

  pagesContainer.querySelectorAll(PDF_PAGE_SELECTOR).forEach((pageWrapper) => {
    const naturalWidth = Number(pageWrapper.dataset.pdfNaturalWidth);
    if (!Number.isFinite(naturalWidth) || naturalWidth <= 0) {
      return;
    }

    const fitScale = Math.min(1, availableWidth / naturalWidth);
    const displayWidth = `${naturalWidth * fitScale * normalizedZoom}px`;
    if (pageWrapper.style.width !== displayWidth) {
      pageWrapper.style.width = displayWidth;
    }
  });
};

